import { useEffect } from "react";
import toast from "react-hot-toast";
import {
  getMessaging,
  getToken,
  isSupported,
  onMessage,
} from "firebase/messaging";

import { CNotification } from "src/common/components/others";

import { app } from "./config";

export const requestPermission = async () => {
  const permission = await Notification.requestPermission();
  return permission;
};

export const FirebaseRoot = () => {
  //#region Data
  const vapidKey =
    "BF5PxHqu_mufvH2fkUrXaQkuxgl_vap-iVH8ozBIzxxmhXQY6zyIHCHvoAiNxZab-YK06daMJhd5N2FlLxfPBYk";
  //#endregion

  //#region Event
  const checkPermissionNotification = async () => {
    const isSup = await isSupported();

    if (!isSup) return;

    const messaging = getMessaging(app);

    const isPermission = await requestPermission();

    if (isPermission === "granted") {
      getToken(messaging, { vapidKey }).then(async (currentToken) => {
        if (currentToken) {
          // await firebaseApi.sendToken(currentToken);
          localStorage.setItem("firebase-token", currentToken);

          onMessage(messaging, (payload) => {
            toast(() => <CNotification notificationPayload={payload} />, {
              duration: 20000,
            });
          });
        } else {
          console.error("Không thể lấy được token cho firebase!");
        }
      });
    }
  };

  const checkServiceWorkerNoti = (event) => {
    if (event?.data && !event.data?.isFirebaseMessaging === true) {
      console.log(event.data);
      // dispatch(setNotifications(formatNotification(event.data)));
    }
  };
  //#endregion

  useEffect(() => {
    checkPermissionNotification();
  }, [app]);

  useEffect(() => {
    navigator?.serviceWorker?.addEventListener(
      "message",
      checkServiceWorkerNoti,
    );
    return () => {
      navigator?.serviceWorker?.removeEventListener(
        "message",
        checkServiceWorkerNoti,
      );
    };
  }, [navigator?.serviceWorker]);

  //#region render
  return <></>;
  //#endregion
};
